import { get, post } from './../Config/config';

export const AssignUser = {

    assign: (data) => post('/inventory/items/assign', data),
    unAssign: (data) => post('/inventory/items/release', data),
    getAssignHistoryTable: (data) => get(`inventory/items/view?id=${data.id} `),
}
